import React from "react";
import AboutPage from "../components/AboutPage";
import FooterSection from "../components/FooterSection";




const About = () => {
    return (
        <>
            <AboutPage />
            <FooterSection />
        </>
    );
};

export default About;